export default {
  id: {
    value: '',
    options: [],
    clearOption: true,
    required: false,
    state: null
  },
  regulationAutoID: {
    value: '',
    options: [],
    clearOption: true,
    required: false,
    state: null
  },
  typeConclusionID: {
    value: '',
    options: [],
    required: false,
    clearOption: true,
    state: null
  },
  reasonFrustration: {
    value: '',
    options: [],
    required: false,
    state: null
  },
  lossTypeID: {
    value: '',
    options: [],
    clearOption: true,
    required: false,
    state: null
  },
  hasNonconformityBudget: {
    value: '',
    options: [],
    required: false,
    state: null
  },
  nonconformityBudgetReason: {
    value: '',
    options: [],
    required: false,
    state: null
  },
  rescheduleInspection: {
    value: '',
    options: [],
    required: false,
    state: null
  },
  emailAdm: {
    value: '',
    maxlength: '2000',
    required: false,
    state: null,
    rows: 3,
    noResize: true
  },
  nonconformityBudgetDescription: {
    value: '',
    maxlength: '2000',
    required: false,
    state: null,
    rows: 3,
    noResize: true
  },
  instructions: {
    value: '',
    maxlength: '2000',
    required: false,
    state: null,
    rows: 2,
    noResize: true
  },
  observations: {
    value: '',
    maxlength: '2000',
    required: false,
    state: null,
    rows: 2,
    noResize: true
  },
  actionDate: {
    value: '',
    maxlength: '30',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/regulation/auto/analyze/sinisteranalyze-form.js